import React, { useEffect, useState } from "react";
import { Title } from "./EmployeeDetails";
import { CreateButton } from "../../../../Components/Utils/Buttons";
import { Button, Modal, notification } from "antd";
import { NuDate, NuTextArea } from "../../../../Components/Utils/Input";
import { useFormik } from "formik";
import axiosInstance from "../../../../Services/axiosCommon";
import { useParams } from "react-router-dom";
import DeleteIcon from "../../../../Components/Icons/Delete";
import EditIcon from "../../../../Components/Icons/Edit";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";

function Requests() {
  const { value: RequestType,getData:refRequestType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Type_RequestLeave"
  );
   const { officeId } = useParams();
    const { ViewEmployeeId } = useParams();
  
    const [create, setCreate] = useState({
      description: "",
      branchId: officeId,
      employeeId:ViewEmployeeId,
      date: "",
      type:"",
    });
    const [EmployeeAtt, setEmployeeAtt] = useState([]);
  
    async function getMembersByProject(officeId) {
      await axiosInstance
        .get(`/employee-requests/${officeId}/details/${ViewEmployeeId}/employee`)
        .then((res) => {
          setEmployeeAtt(res?.data?.data?.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            setEmployeeAtt([]);
          }
          console.log(error);
        });
    }
    useEffect(() => {
      getMembersByProject(officeId);
    }, []);
    const [openAll, setOpenAll] = useState(false);
    const [employee, setEmployee] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    const [isLoading, setIsLoading] = useState(false);
  
    function OpenFunction(item) {
      setEmployee(item?.id);
      setCreate({
        description: item?.description || "",
        branchId: officeId,
        employeeId: ViewEmployeeId,
        date: item?.date || "",
        type:item?.type,
      });
      setEditMode(true);
      setOpenAll(true);
    }
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: create,
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: async (value, { resetForm }) => {
        const apiUrl = editMode
          ? `/employee-requests/${employee}`
          : `/employee-requests/`;
  
        const method = editMode ? "put" : "post";
  
        setIsLoading(true);
        axiosInstance[method](apiUrl, value)
          .then((res) => {
            if (
              res.status === 200 ||
              res.status === 201 ||
              res.data.status === true
            ) {
              api.success({
                message: `Success`,
                description: res?.data?.msg || "Operation completed",
                placement: "bottomRight",
              });
              resetForm();
              setOpenAll(false);
              getMembersByProject(officeId);
            } else {
              api.error({
                message: `Failed`,
                description: res?.data?.msg || "Something went wrong",
                placement: "bottomRight",
              });
            }
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log(error);
          });
      },
    });
    function CloseFunction() {
      setCreate({
        description: "",
        branchId: officeId,
         type:"",
        date: "",
      });
      setEmployee("");
      setOpenAll(false);
    }
    const handleDeleteComment = (id) => {
      Modal.confirm({
        title: "Are you sure you want to delete this Request?",
        width: "25%",
        centered: true,
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          axiosInstance
            .delete(`/employee-requests/${id}`)
            .then((res) => {
              if (res.status === 200 || res.data.status === true) {
                api.success({
                  message: "Deleted",
                  description: res?.data?.msg || "Request deleted successfully",
                  placement: "bottomRight",
                });
                getMembersByProject(officeId);
              }
            })
            .catch((err) => console.error(err));
        },
      });
    };
  return (
        <div className=" w-full h-full py-3">
            <div className=' flex justify-between items-center'>
            <Title value="Requests : " />
                   <CreateButton handleClick={() => setOpenAll(true)} />
              </div>
            <div className='w-full h-[calc(100%-2.5rem)] mt-3  relative'>
          <div className=' w-full bg-textColor-main static text-white top-0'>
            <table className=' w-full '>
              <thead>
                <tr className=' w-full' >
                  <th className=' py-2 text-xs font-medium w-[5%] ' >Sl.No</th>
                  <th className=' py-2 text-xs font-medium w-[55%] text-left'>Request For</th>
                  <th className=' py-2 text-xs font-medium w-[10%] ' >Type</th>
                  <th className=' py-2 text-xs font-medium w-[15%]' >Date</th>
                  <th className=' py-2 text-xs font-medium w-[15%] '>Status</th>
                  <th className=' py-2 text-xs font-medium w-[5%]'>Action</th>
                </tr>
              </thead>
                <tbody>
                            {
                              EmployeeAtt?.map((item, index) => (
                                <tr className="odd:bg-white even:bg-slate-50 " key={index}>
                                  <td className="py-1 text-xs text-center font-medium w-[5%] text-[#4f4768]">
                                    {" "}
                                    {item?.sno || index + 1}
                                  </td>
                                  <td className="py-1 text-xs font-medium w-[55%] text-[#4f4768]">
                                    {item?.description}{" "}
                                  </td>
                                  <td className="py-1 text-xs text-center font-medium w-[10%] text-[#4f4768]">
                                    {item?.type}{" "}
                                  </td>
                                  <td className="py-1 text-xs text-center font-medium w-[15%] text-[#4f4768]">
                {item?.date ? new Date(item.date).toLocaleDateString('en-GB') : ''}
              </td>
              <td className="py-1 text-xs font-medium w-[15%] text-center text-[#4f4768]">
                                    {item?.status}{" "}
                                  </td>
                                
                                  <th className=" py-2 text-xs flex px-2 font-medium w-[5%]">
                                    {" "}
                                    <span
                                      onClick={() => OpenFunction(item)}
                                      className="cursor-pointer text-blue-500"
                                    >
                                      <EditIcon  color="skyblue"/>
                                    </span>
                                    <span
                                      onClick={() => handleDeleteComment(item?.id)}
                                      className="cursor-pointer text-red-500"
                                    >
                                      <DeleteIcon />
                                    </span>
                                  </th>
                                </tr>
                              ))}
                          </tbody>
            </table>
          </div>
          <div>

          </div>
        </div>
         <Modal
                open={openAll}
                title={editMode ? "Edit Request" : "Add Request"}
                width={"35%"}
                className="my-modal"
                centered
                onCancel={CloseFunction}
                footer={[]}
              >
                <form onSubmit={formik.handleSubmit}>
                  <NuDate
                    label=" Date"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="date"
                    width="w-full "
                  />
                   <DropDownAddMetaData
                          label="Type"
                          placeholder="Choose"
                          Options={RequestType}
                          formik={formik}
                          name="type"
                          width="w-full"
                          getFunc={refRequestType}
                          displayProperty={"Type"}
                          propertyName={"Type_RequestLeave"}
                          FixPosition={false}
                          PortalTarget={false}
              // isRequired={true}

                        />
                  <NuTextArea
                    label="Description"
                    placeholder="Description"
                    formik={formik}
                    name="description"
                    width="w-full"
                    new_width="w-full"
                  />
        
                  <div className="w-full px-6">
                    <Button
                      htmlType="submit"
                      size="large"
                      loading={isLoading}
                      className="w-full bg-[#3267FF] text-white mx-auto"
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              </Modal>
        </div>
  )
}

export default Requests